import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay
} from '@chakra-ui/react'
import VisitForm from './components/VisitForm'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

interface Props {
  isOpen: boolean
  onClose: () => void
  isEditMode?: boolean
  currentVisitValues?: any
  patientName: string
  sortOrder: 'ASC' | 'DESC'
  isFollowUp: boolean
}

export default function VisitFormModal({
  isOpen,
  onClose,
  patientName,
  ...restProps
}: Props) {
  const { locale } = useIntl()

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      placement={locale.startsWith('ar') ? 'left' : 'right'}
    >
      <DrawerOverlay backdropFilter="blur(2px)" />
      <DrawerContent>
        <DrawerHeader borderBottom="1px solid" borderColor="gray.200">
          <FormattedMessage
            {...(restProps.isEditMode ? messages.editVisit : messages.addVisit)}
            values={{ patientName }}
          />
        </DrawerHeader>
        <DrawerCloseButton />
        <DrawerBody overflowY="auto" p={0}>
          <VisitForm onClose={onClose} {...restProps} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}
